// extracted by mini-css-extract-plugin
module.exports = {"totalLabel":"CommissionsWidget_totalLabel__182hn"};